import { Button } from "@/components";
import { FONT, RADIUS } from "@/styles/common";
import theme from "@/styles/theme";
import { Center, Flex } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const Wrapper = styled(Center)`
    border: 1px solid ${({ theme }) => theme.COLOR.gray[300]};
    ${RADIUS(4)}

    @media (max-width:${({ theme }) => theme.MEDIA.tablet}) {
        border: none;
    }
`;
interface CustomButtonProps {
    isAvailableBook: boolean;
}

export const CustomPrice = styled(Flex)`
    ${FONT("pretendard", 16, 300)}
`;
export const CustomButton = styled(Button)<CustomButtonProps>`
    ${FONT("pretendard", 16, 700)}
    color: ${({ isAvailableBook }) =>
        isAvailableBook ? ({ theme }) => theme.COLOR.black : ({ theme }) => theme.COLOR.white};
    background: ${({ isAvailableBook }) =>
        isAvailableBook ? ({ theme }) => theme.COLOR.white : ({ theme }) => theme.COLOR.gray[400]};
    border: ${({ isAvailableBook }) => (isAvailableBook ? `1px solid ${theme.COLOR.gray[500]}` : "none")};

    &.check {
        color: ${({ theme }) => theme.COLOR.white};
        background: ${({ theme }) => theme.COLOR.pink[200]};
        border: none;
    }
`;
